import { gql, useMutation } from '@apollo/client';
import { Obj } from '@livecontrol/core-utils';
import type { MutationResult } from '@livecontrol/scheduler/store';
import { Errors } from '@livecontrol/scheduler/store';
import { useCallback } from 'react';

const MUTATION = gql`
mutation GenerateMultipartAssetSignedUrl($clientId: Int!, $assetId: Int!, $totalParts: Int!) {
  GenerateMultipartAssetSignedUrl(client_id: $clientId, asset_id: $assetId, total_parts: $totalParts) {
    destination_url
    error
    upload_urls
    upload_id
  }
}
`;

interface TVariables {
    clientId: number;
    assetId: number;
    totalParts: number;
}

interface TData {
    GenerateMultipartAssetSignedUrl: {
        destination_url?: string;
        error?: boolean;
        upload_urls?: string[];
        upload_id?: string;
    };
}

type Args = Partial<TVariables>;
type AssetSignedUrl = TData['GenerateMultipartAssetSignedUrl'];

export const useMultipartGenerateUrls = (): [
    (args: Args) => Promise<AssetSignedUrl | undefined>,
    MutationResult<AssetSignedUrl>
] => {
    const [mutation, { loading, called, data }] = useMutation<TData, TVariables>(MUTATION);

    return [
        useCallback(async (args: Args) => {
            let data_: AssetSignedUrl |  undefined;

            try {

                if (!Obj.isHydrated(args)) {
                    throw Errors.badRequest();
                }

                const response = await mutation({ variables: args });

                data_ = response.data?.GenerateMultipartAssetSignedUrl;
            } catch {
                //
            }

            return data_;
        }, [mutation]),
        {
            loading,
            called,
            data: data?.GenerateMultipartAssetSignedUrl
        }
    ];
};
